export default theme => ({
  menuItem: {
    "&:hover": {
      textDecoration: "none",
      backgroundColor: theme.palette.primary.light,
      cursor: "pointer",
    },
  },
  disabledElement: {
    color: theme.palette.disabled.light,
  },
  link: {
    color: theme.palette.primary.main,
  },
});
